import React, { Component } from 'react';
import { Link } from "react-router-dom";
import Settings from '../../inc/Settings';
import AuthCheck from './AuthCheck';
import LoginForm from './Login/LoginForm'; 
class LoginRegisterTab extends Component {
    render() {
        let logo = '/images/login-reg-screen-logo.png';
        return (
            <div className='loginreg_contents'>
                <div className='login_regiser_box'>
                    <AuthCheck noAccessForLogin={"/"+Settings.redirectUrlAfterLogin}/>
                    <Link to="/" className='login_logo'><img src={logo} alt="Lynkaz"/></Link>
                    <div className='lr_box_inner'>
                        <div className='log_reg_th'>
                            <Link to="/login" className={ this.props.tab === "login" ? 'active' : '' } >Login </Link> 
                        </div>
                        { this.props.tab === "login" && <LoginForm/> }
                    </div>
                </div>
            </div>
        );
    }
}

export default LoginRegisterTab;